import * as Factory from 'factory.ts'
import faker from 'faker'

import { CurrencyFactory } from '@webapp/core/entities/external/Currency/Currency.factory'
import { EntityFactory } from '@webapp/core/utils/mocks/EntityFactory'
import { ExpenseDraft, type ExpenseDraftConstructor } from './ExpenseDraft'
import {
  ExpenseDraftItem,
  type ExpenseDraftItemConstructor,
} from './ExpenseDraftItem'
import { ExpenseStatuses } from '../enums/ExpenseStatusEnum'
import { ExpenseTypes } from '../enums/ExpenseTypeEnum'

export const ExpenseDraftItemConstructorFactory =
  Factory.Sync.makeFactory<ExpenseDraftItemConstructor>({
    id: Factory.each(() => faker.random.number()),
    merchant: Factory.each(() => faker.company.companyName()),
    accountId: Factory.each(() => faker.random.number()),
    reimbursable: Factory.each(() => faker.random.boolean()),
    expenseType: ExpenseTypes.OTHER,
    paymentType: Factory.each(() => faker.random.number({ min: 0, max: 3 })),
    amount: Factory.each(() => parseFloat(faker.commerce.price())),
    taxPercentage: Factory.each(() =>
      faker.random.number({ min: 0, max: 25 }).toFixed(2)
    ),
    currency: Factory.each(() => CurrencyFactory.build()),
    transactionDate: Factory.each(
      () => faker.date.past().toISOString().split('T')[0]
    ),
    attachment: Factory.each(() => faker.random.uuid()),
    notes: Factory.each(() => faker.lorem.sentence()),
    expenseTypeFields: null,
    taxAmount: Factory.each(() => parseFloat(faker.commerce.price(0, 50))),
    taxId: null,
    creditCardId: null,
    account: Factory.each(() => ({
      id: faker.random.number(),
      accountCode: {
        id: faker.random.number(),
        code: faker.finance.account(4),
        description: faker.commerce.department(),
      },
    })),
    creditCard: null,
  })

export const ExpenseDraftItemFactory = EntityFactory(
  ExpenseDraftItem,
  ExpenseDraftItemConstructorFactory
)

export const ExpenseDraftConstructorFactory =
  Factory.Sync.makeFactory<ExpenseDraftConstructor>({
    id: Factory.each(() => faker.random.number()),
    uuid: Factory.each(() => faker.random.uuid()),
    title: Factory.each(() => faker.lorem.sentence()),
    status: ExpenseStatuses.DRAFT,
    departmentId: Factory.each(() => faker.random.number()),
    locationId: Factory.each(() => faker.random.number()),
    nextApproverId: null,
    travel: null,
    notes: Factory.each(() => faker.lorem.sentence()),
    createdDate: Factory.each(
      () => faker.date.past().toISOString().split('T')[0]
    ),
    items: Factory.each(() => ExpenseDraftItemConstructorFactory.buildList(1)),
  })

export const ExpenseDraftFactory = EntityFactory(
  ExpenseDraft,
  ExpenseDraftConstructorFactory
)
